module.exports = __webpack_public_path__ + "img/posture_perfect4.0eb065ae.png";